import { Component, Input } from '@angular/core';

@Component({
  selector: 'lib-banner',
  imports: [],
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.scss',
})
export class BannerComponent {
  @Input() message: string = '';
}
